var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SaaSLayout',{ref:"layout",attrs:{"show-sidebar":_vm.isOnlyContent,"show-tag-view":_vm.isOnlyContent,"header":{
    dropdownList: _vm.dropdownList
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }